import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsProviderModel from './pcs-provider';
import type PcsCompanyLoadModel from './pcs-company-load';

export default class PcsProviderLoadModel extends Model {
  @attr declare actual: number;
  @attr declare amount: number;
  @attr declare cover: number;
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare providerData: Record<string, unknown>;
  @attr declare state: string;
  @attr declare transitionLog: Record<string, unknown>;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-provider', { async: false, inverse: null })
  declare pcsProvider: PcsProviderModel;

  @hasMany('pcs-company-load', { async: false, inverse: 'pcsProviderLoad' })
  declare pcsCompanyLoads: PcsCompanyLoadModel[];

  [Type] = 'pcs-provider-load' as const;
}
